/**
 * Feature toggle constants
 */

const Feature = {
    POLL: 'poll',
    FRIDAY: 'friday',
    VIDEO: 'video',
    RADIO: 'radio',
    COMMENTS: 'comments',
    TOTAL_COMMENTS: 'totalComments',
    REPLY_COMMENTS: 'replyComments',
    LOGIN: 'login',
    BOOKMARKS: 'bookmarks',
    SIDEBAR: 'sidebar',
    SHARE: 'share',
    LOGIN_MODAL: 'loginModal',
    RECOMMENDER_STORY: 'recommenderStory',
    RECOMMENDER_VIDEO: 'recommenderVideo',
    DEEPLINK_SLIDER: 'deeplinkSlider',
    OUTBRAIN: 'outbrain',
    EXTERNAL_DEPENDENCIES: 'externalDependencies',
    LANGUAGE_INFO_BAR: 'languageInfoBar',
    LIFESTYLE: 'lifestyle',
    SUDOKU: 'sudoku',
    CMP: 'cmp',
    MOST_COMMENTED: 'mostCommented',
    RECENTLY_COMMENTED: 'recentlyCommented'
};

export {Feature};
